<template>
  <div id="presenca-aluno">
    <div id="presenca-img" v-show="modal.show">
      <!-- <img id="finger-img"> -->

      <div v-if="cpfDiv" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
        <div class="row">
          <div class="col-md-12">
            <strong class="font-weight-bold">Digíte seu CPF</strong>
            <InputIconGroup
              iconInput="fa fa-info"
              typeInput="text"
              idInput="cpf"
              labelInput="CPF"
              :inputMask="['###########']"
            ></InputIconGroup>
            <button @click="presencaOpen" class="btn btn-primary">Confirmar</button>
            <br />
            <br />
            <div class="container" style="text-align:center;">
              <template v-if="online">
                <span class="circle badge-success"></span> Online
              </template>
              <template v-if="!online">
                <span class="circle badge-danger"></span> Offline
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="fingerprint" class="col-sm-12 col-lg-12 col-xl-12">
        <div class="row text-center justify-content-center">
          <img height="200" width="200" src="~assets/fingerprint.png" />
        </div>
        <br />
        <div class="row text-center justify-content-center">
          <h1>Insira sua Digital</h1>
        </div>
      </div>
      <vuestic-modal
        id="modal-photo"
        ref="photoModal"
        :cancelClass="'none'"
        :okClass="'none'"
        :closeIconShown="false"
      >
        <div class="col-sm-12 col-lg-12 col-xl-12">
          <div class="row justify-content-center text-center">
            <div class="col-md-6">
              <img id="mask" height="250" width="250" src="~assets/mask.png" />
              <video id="player" width="250" height="250" autoplay></video>
              <button @click="captureSnapshot" id="capture" class="btn btn-primary">Capturar</button>
            </div>
            <div class="col-md-6">
              <canvas id="snapshot" width="250" height="250"></canvas>
              <button @click="sendSnapshot" id="send" class="btn btn-primary" disabled>Enviar</button>
            </div>
          </div>
        </div>
      </vuestic-modal>
    </div>
    <div id="presenca-load" v-show="modal.load" class="text-center justify-content-center">
      <div class="col-sm-12 col-lg-12 col-xl-12 text-center justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SemipolarSpinner'"
          :color="'#4AE387'"
          :size="289"
        ></component>
      </div>
    </div>
    <vuestic-modal
      id="modal-user"
      ref="smallModal"
      :cancelClass="'none'"
      :okClass="'none'"
      :closeIconShown="false"
    >
      <div>
        <div slot="Dados Básicos">
          <div class="col-md-12 modal-text">
            <img id="avatar-img" height="200" width="200" src="~assets/avatar.png" />
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 modal-text">
              <strong id="tipo-presenca" class="font-weight-bold"></strong>
            </div>
            <div class="col-md-6 modal-text">
              <strong class="font-weight-bold">CPF:</strong>
              <br />
              {{modal.conteudo.cpf}}
            </div>
            <div class="col-md-6 modal-text">
              <strong class="font-weight-bold">Nome:</strong>
              <br />
              {{modal.conteudo.nome}}
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 modal-text">
              <strong class="font-weight-bold">Aula</strong>
            </div>
            <div id="timestamp" class="col-md-12 modal-text"></div>
          </div>
          <br />
          <!-- <div class="col-md-12 modal-text">
                        <img id="finger-img" height="800" width="384">
          </div>-->
          <div class="row">
            <div class="col-md-12" style="text-align: center; font-size: 25px;">
              <img height="30" width="30" src="~assets/check.png" /> Presença Confirmada
            </div>
          </div>
        </div>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import PresencaController from './PresencaController'
import BiometricsController from './BiometricsController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'

window._ = require('lodash')

export default {
  components: {
    ...spinners,
    InputIconGroup,
    urlApi
  },
  data () {
    return {
      online: false,
      modal: {
        show: true,
        load: false,
        conteudo: {}
      },
      usbButton: true,
      device: '',
      blob: '',
      usbTentativas: 0,
      fotoTentativas: 0,
      fingerprint: false,
      photo: false,
      cpfDiv: true,
      cpfInput: '',
      cpfType: ''
    }
  },
  mounted (event) {
    let self = this
    self.$emit('onPresenca', false)

    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        self.presencaOpen()
      }
    })
  },
  destroyed (event) {
    this.$emit('onPresenca', true)
  },
  methods: {
    loadData (cpf) {
      let self = this

      if (self.cpfType === 'aluno') {
        PresencaController.getDataAlunoByCPF(cpf, function (response) {
          self.online = true
          if (response.data.sucesso == false) {
            self.usbTentativas = 0
            self.fotoTentativas = 0
            PresencaController.launchToast('fa-times', response.data.dados)
          } else {
            self.modal.conteudo = response.data.dados
            document.getElementById('timestamp').innerHTML = self.getTime()
            document.getElementById('tipo-presenca').innerHTML = 'Aluno'
            self.$refs.smallModal.open()
            self.usbTentativas = 0
            self.fotoTentativas = 0
            setTimeout(function () {
              self.$refs.smallModal.close()
            }, 5000)
          }
        })
      } else if (self.cpfType === 'instrutor') {
        PresencaController.getDataInstrutorByCPF(cpf, function (response) {
          self.online = true
          if (response.data.sucesso == false) {
            self.usbTentativas = 0
            self.fotoTentativas = 0
            console.log('teste')
            PresencaController.launchToast('fa-times', response.data.dados)
          } else {
            self.modal.conteudo = response.data.dados
            document.getElementById('timestamp').innerHTML = self.getTime()
            document.getElementById('tipo-presenca').innerHTML = 'Instrutor'
            self.$refs.smallModal.open()
            self.usbTentativas = 0
            self.fotoTentativas = 0
            setTimeout(function () {
              self.$refs.smallModal.close()
            }, 5000)
          }
        })
      }

      self.cpfDiv = true
      self.fingerprint = false
      self.photo = false
      self.$data.modal.show = !self.$data.modal.show
      self.$data.modal.load = !self.$data.modal.load
    },

    getTime () {
      var date = new Date()
      var month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var now =
        date.getDate() +
        '-' +
        month +
        '-' +
        date.getFullYear() +
        ' | ' +
        date.getHours() +
        ':' +
        date.getMinutes() +
        ':' +
        date.getSeconds()
      return now
    },

    async getDevice () {
      let self = this
      self.usbButton = false
      self.device = await BiometricsController.init()
      await self.getFrame(self.device)
    },
    async getFrame (device) {
      let self = this
      self.cpfDiv = false
      self.photo = false
      self.fingerprint = true
      BiometricsController.getImage(device).then(
        function (imageData) {
          self.$data.modal.show = !self.$data.modal.show
          self.$data.modal.load = !self.$data.modal.load
          self.processFinger(imageData)
        },
        function (err) {
          self.getFrame(device)
        }
      )
    },

    async processFinger (arrFinger) {
      let self = this

      self.loadData(self.cpfInput)
      return

      const ws = await new WebSocket('ws://52.67.248.176:5678//')

      ws.onopen = function () {
        self.online = true
        ws.send(['FINGER_1', arrFinger])
      }

      ws.onmessage = function (event) {
        console.log(event.data)
        if (event.data === 'PROCESS_FINGER1_OK') {
          ws.send(['FINGER_2', self.dig1])
        } else if (event.data == 'MATCH') {
          self.loadData(self.cpfInput)
          ws.close(1000, 'Closing...')
        } else if (event.data == 'NO_MATCH') {
          self.$data.modal.show = !self.$data.modal.show
          self.$data.modal.load = !self.$data.modal.load
          self.cpfDiv = true
          self.fingerprint = false
          self.photo = false
          PresencaController.launchToast('fa-times', 'Erro de Leitura!')
          ws.close(1000, 'Closing...')
        }
      }

      ws.onerror = function (event) {
        self.online = false
        self.$data.modal.show = true
        self.$data.modal.load = false
        self.cpfDiv = true
        self.fingerprint = false
        self.photo = false
        PresencaController.launchToast('fa-times', 'Erro')
        console.log(event)
        ws.close(1000, 'Closing...')
      }

      // const nWidth = 379;
      // const nHeight = 150;
      // // var buffer = new Uint8ClampedArray(nWidth * nHeight * 4);

      // // console.log(arrFinger)

      // // for(let i = 0; i < arrFinger.length; i++){
      // //     buffer[i] = arrFinger[i]
      // // }

      // var canvas = document.createElement('canvas')
      // var ctx = canvas.getContext('2d');

      // canvas.width = nWidth;
      // canvas.height = nHeight;

      // // create imageData object
      // var idata = ctx.createImageData(nWidth, nHeight);

      // let i = 0
      // for(var y = 0; y < nHeight; y++) {
      //     for(var x = 0; x < nWidth; x++) {
      //         var pos = (y * nWidth + x) * 4; // position in buffer based on x and y
      //         idata.data[pos  ] = arrFinger[pos];         // some R value [0, 255]
      //         idata.data[pos+1] = arrFinger[pos+1];        // some G value
      //         idata.data[pos+2] = arrFinger[pos+2];       // some B value
      //         idata.data[pos+3] = 255;           // set alpha channel
      //         i++;

      //         // buffer[pos  ] = arrFinger[pos];         // some R value [0, 255]
      //         // buffer[pos+1] = arrFinger[pos+1];        // some G value
      //         // buffer[pos+2] = arrFinger[pos+2];       // some B value
      //         // buffer[pos+3] = 255;           // set alpha channel
      //     }
      // }

      // // idata.data.set(buffer);

      // ctx.putImageData(idata, 0, 0);

      // document.getElementById('finger-img').src = canvas.toDataURL();

      // self.loadDataAluno(1);
    },

    processPhoto () {
      let self = this
      navigator.mediaDevices
        .getUserMedia({ video: { width: 250, height: 250 } })
        .then(function (stream) {
          document.getElementById('player').srcObject = stream

          self.fingerprint = false
          self.$refs.photoModal.open()
        })
        .catch(function (err) {
          console.log(err)
        })
    },

    captureSnapshot () {
      var snapshotCanvas = document.getElementById('snapshot')
      snapshotCanvas
        .getContext('2d')
        .drawImage(
          document.getElementById('player'),
          0,
          0,
          250,
          250
        )
      document.getElementById('send').disabled = false
    },

    sendSnapshot () {
      let self = this
      var cpf = document.getElementById('cpf').value

      self.$refs.photoModal.close()

      self.$data.modal.show = !self.$data.modal.show
      self.$data.modal.load = !self.$data.modal.load

      var data = {
        foto: document.getElementById('snapshot').toDataURL(),
        cpf: cpf
      }

      PresencaController.sendSnapshot(data, function (response) {
        var size = response.data.dados[1]
        var conf = response.data.dados[2]

        console.log('Conf: ' + conf ** 2 / size)
        console.log('Size: ' + size)

        self.loadData(cpf)

        // PresencaController.launchToast('fa-check', lim)

        // if (size < 150) {
        //   PresencaController.launchToast(
        //     'fa-times',
        //     'Aproxime e enquadre o rosto na guia!'
        //   )
        //   self.$data.modal.show = !self.$data.modal.show
        //   self.$data.modal.load = !self.$data.modal.load
        // } else if (size > 170) {
        //   PresencaController.launchToast(
        //     'fa-times',
        //     'Afaste e enquadre o rosto na guia!'
        //   )
        //   self.$data.modal.show = !self.$data.modal.show
        //   self.$data.modal.load = !self.$data.modal.load
        // } else if (conf ** 2 / size > 60) {
        //   PresencaController.launchToast('fa-times', 'Foto inválida!')
        //   self.$data.modal.show = !self.$data.modal.show
        //   self.$data.modal.load = !self.$data.modal.load
        // } else {
        //   // PresencaController.launchToast('fa-check', 'Sucesso!')
        //   // self.$data.modal.show = !self.$data.modal.show
        //   // self.$data.modal.load = !self.$data.modal.load
        //   self.loadData(cpf)
        // }
      })

      // var formData = new FormData();
      // document.getElementById('snapshot').toBlob(function(blob){

      //     formData.append('foto', blob, 'foto.png');
      //     formData.append('cpf', document.getElementById('cpf').value);
      //     formData.append('tipo', self.entidade);

      // });
    },

    presencaOpen () {
      let self = this

      let cpf = document.getElementById('cpf').value

      if (!cpf) {
        PresencaController.launchToast('fa-times', 'Digite um CPF!')
        return
      }

      self.$http
        .post(urlApi + '/cfc/cpf', { cpf: cpf })
        .then(function (response) {
          self.online = true
          self.cpfInput = cpf
          self.cpfType = response.data.dados.type

          self.processPhoto()

          // self.dig1 = response.data.dados.dig1

          // self.cpfDiv = false
          // self.photo = false
          // self.fingerprint = true
          // self.$data.modal.show = !self.$data.modal.show
          // self.$data.modal.load = !self.$data.modal.load

          // self.loadData(self.cpfInput)

          // self.getDevice();
        })
        .catch(function (error) {
          console.log(error)
          PresencaController.launchToast('fa-times', error.data.dados)
        })
    }
  }
}
</script>

<style type="text/css">
.circle {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  display: inline-block;
}

#presenca-load {
  margin-top: 300px;
  margin-right: 284px;
}

#presenca-img {
  margin-top: 300px;
  margin-right: 284px;
}

.button-presenca {
  margin-right: 50px;
}

#avatar-img {
  border: 10px solid #ddd;
  border-radius: 20px;
  padding: 10px;
}

#finger-img {
  border: 10px solid #ddd;
  border-radius: 20px;
  padding: 10px;
}

.modal-text {
  text-align: center;
  font-size: 50px;
}

#player {
  position: relative;
}

#mask {
  position: absolute;
  z-index: 900;
}
</style>
